export default "__VITE_ASSET__b813bcb5__"